import { useRef } from 'react'

// A cache refresh must not replace the lyrics of an existing performance.
export default function usePinnedSongLyrics(song, performanceKey) {
  const snapshot = useRef(null)
  if (snapshot.current?.key !== performanceKey || snapshot.current?.songId !== song?.id) {
    snapshot.current = { key: performanceKey, songId: song?.id, song: null }
  }
  if (!snapshot.current.song && (song?.lyrics?.length || song?.wordLevelTranscription?.length)) {
    snapshot.current.song = song
  }
  return snapshot.current.song || song
}
